<div class="welcome-title-banner">
  <ng-container *ngIf="carrierLogo$ | async">
    <div class="image-box">
      <app-image class="logo" [src]="(carrierLogo$ | async) ?? ''"></app-image>
    </div>
  </ng-container>
  <h2 class="welcome-title">Travelers questionnaire</h2>
</div>

<form *ngIf="formGroup" [formGroup]="formGroup">
  <emperor-radio-button
    [formControlName]="TravelersComplianceQuestionKeys.HasDirectAppointment"
    label="Does your agency currently hold a Traveler's Personal Lines direct appointment?"
    class="compliance-question"
    [choices]="yesNoChoices"
    excludeSubscript
  ></emperor-radio-button>

  <emperor-text-input
    [formControlName]="
      TravelersComplianceQuestionKeys.YearsCommercialExperience
    "
    label="How many years experience does the agency have writing commercial accounts?"
    type="number"
    [min]="0"
  ></emperor-text-input>

  <label [formArrayName]="TravelersComplianceQuestionKeys.TopCarriers">
    Who are your top 3 commercial carriers by volume?
    <span>
      <emperor-text-input
        *ngFor="let control of topCarriersFormArray.controls; let i = index"
        [formControlName]="i.toString()"
        placeholder="Carrier name"
        class="nested-input-label"
      ></emperor-text-input>
    </span>
  </label>

  <label [formArrayName]="TravelersComplianceQuestionKeys.TopIndustries">
    What are your top 3 industries by policy count?
    <span>
      <emperor-text-input
        *ngFor="let control of topIndustriesFormArray.controls; let i = index"
        [formControlName]="i.toString()"
        placeholder="Industry name"
        class="nested-input-label"
      ></emperor-text-input>
    </span>
  </label>

  <emperor-masked-input
    [formControlName]="TravelersComplianceQuestionKeys.TotalPremium"
    label="What is your agency's total written premium?"
    [iconPrefix]="{ showPrefix: true, icon: 'sign_dollar' }"
    [mask]="currencyMask"
  ></emperor-masked-input>

  <emperor-masked-input
    [formControlName]="TravelersComplianceQuestionKeys.CommercialPercentage"
    label="What percentage of your total written premium is attributed to commercial lines?"
    [mask]="percentageMask"
    [iconPrefix]="{ showPrefix: true, icon: 'percent_circle' }"
  ></emperor-masked-input>

  <emperor-masked-input
    [formControlName]="TravelersComplianceQuestionKeys.WCPremiumPercentage"
    label="What percentage of your total written premium is attributed to workers compensation coverage?"
    [mask]="percentageMask"
    [iconPrefix]="{ showPrefix: true, icon: 'percent_circle' }"
  ></emperor-masked-input>

  <emperor-radio-button
    [formControlName]="TravelersComplianceQuestionKeys.CaptiveCarrierAffiliated"
    label="Are you currently affiliated with a captive carrier?"
    class="compliance-question"
    [choices]="yesNoChoices"
    excludeSubscript
  ></emperor-radio-button>

  <label>
    Who should be designated as the Agency User Administrator (the contact who
    manages ID's for the producer code)?
    <span>
      <emperor-text-input
        [formControlName]="
          TravelersComplianceQuestionKeys.AgencyUserAdministratorName
        "
        label="Full name"
        class="nested-input-label"
      ></emperor-text-input>
      <emperor-text-input
        [formControlName]="
          TravelersComplianceQuestionKeys.AgencyUserAdministratorEmail
        "
        label="Email"
        class="nested-input-label"
      ></emperor-text-input>
    </span>
  </label>
</form>
